import { Toast } from '../components/Common/Toast';
import { callAPI } from './api.service';
import { CharacterModel } from '../interfaces/character.interface';
import { BookModel } from '../interfaces/book.interface';
import { HTTPStatusEnum } from '../interfaces/log.interface';
import { UserModel } from '../interfaces/user.interface';

export const getAdminUserByEmail = async (email: string): Promise<UserModel | null> => {
  try {
    const response = await callAPI(`admin/user/by-email?email=${encodeURIComponent(email)}`, null, 'GET');
    if (response?.status === HTTPStatusEnum.OK && response?.user) {
      return response.user as UserModel;
    }
    return null;
  } catch (error) {
    Toast('Error fetching user', true);
    return null;
  }
};

export const getAdminUserBooks = async (
  email: string,
  booksPageNumber: number,
  getAllBooks?: boolean,
): Promise<{ books: BookModel[]; totalBooksPages: number }> => {
  try {
    const response = getAllBooks
      ? await callAPI(`api/booklist?email=${email}&pageNumber=${booksPageNumber}`)
      : await callAPI(`api/booklist/last-session?email=${email}&pageNumber=${booksPageNumber}`);
    if (response.status === HTTPStatusEnum.OK) {
      return {
        books: response?.books || [],
        totalBooksPages: response?.totalBooksPages || 0,
      };
    }
    Toast('Something went wrong', true);
    return { books: [], totalBooksPages: 0 };
  } catch (error) {
    Toast('Error fetching user books', true);
    throw error;
  }
};

export const getAdminUserCharacters = async (email: string): Promise<CharacterModel[]> => {
  try {
    const response = await callAPI(`api/character-library?email=${encodeURIComponent(email)}`);
    return response?.data || [];
  } catch (error) {
    Toast('Error fetching user characters', true);
    throw error;
  }
};
